module.exports = __webpack_public_path__ + "static/img/二维码.0322590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/二维码.jpg
// module id = IcLH
// module chunks = 13